import { createReducer } from '@reduxjs/toolkit'
import {
  updateTreeData
  updateNodeData
  setTreeData
  setNodeData
  setRoots
  setExpandedKeys
  deleteAction
  deleteMacro
  deleteView
} from 'Actions/homeTree'

initialState = {
  expandedKeys: []
  nodeData: {}
  roots: []
  treeData: {}
}

deleteTreeNode = (state, path, id) ->
  _.unset(state.nodeData, "#{path}/#{id}")
  {
    nodeData: state.nodeData
    treeData: {
      state.treeData...,
      "#{path}": state.treeData[path].filter((node) -> node isnt id)
    }
  }

export default createReducer(initialState, {
  [setRoots]: (state, action) ->
    state.roots = action.payload
    undefined
  [setTreeData]: (state, action) ->
    state.treeData = action.payload
    undefined
  [setNodeData]: (state, action) ->
    state.nodeData = action.payload
    undefined
  [updateTreeData]: (state, action) ->
    { key, children } = action.payload
    state.treeData = {
      state.treeData...,
      [key]: [children...]
    }
    undefined
  [updateNodeData]: (state, action) ->
    state.nodeData = {
      state.nodeData...,
      action.payload...
    }
    undefined
  [setExpandedKeys]: (state, action) ->
    state.expandedKeys = action.payload
    undefined
  [deleteAction]: (state, action) ->
    { nodeData, treeData } = deleteTreeNode(state, 'all_actions', action.payload)
    state.nodeData = nodeData
    state.treeData = treeData
    undefined
  [deleteMacro]: (state, action) ->
    { nodeData, treeData } = deleteTreeNode(state, 'all_macros', action.payload)
    state.nodeData = nodeData
    state.treeData = treeData
    undefined
  [deleteView]: (state, action) ->
    { nodeData, treeData } = deleteTreeNode(state, 'all_queries', action.payload)
    state.nodeData = nodeData
    state.treeData = treeData
    undefined
})
